import { useState } from "react";
import Logo from "../assets/images/logo1.png";
import Flageeuu from "../assets/images/banderaeeuu.png";
import Flagspain from "../assets/images/spain.png";
import { FaPhoneVolume } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);

  const { t, i18n } = useTranslation();

  // Configuración de idiomas
  const languages = {
    en: { name: "English", flag: Flageeuu },
    es: { name: "Español", flag: Flagspain },
  };

  const currentLang = languages[i18n.language as keyof typeof languages] 
  ? i18n.language as keyof typeof languages 
  : "en";

  const changeLanguage = (lng: "en" | "es") => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      const navbarHeight = 90; // Ajusta según la altura real del navbar
      const yOffset = -navbarHeight;
      const y = section.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-20 bg-bgPrimary text-white">
      <div className="2xl:pl-56 mx-auto flex justify-between items-center h-[70px] lg:h-[70px] w-full pl-4 pr-2 lg:pr-8">
        {/* Logo */}
        <div className="flex items-center space-x-4">
          <img
            alt="no encontrado"
            className="object-cover w-[100px] lg:w-[120px] h-full cursor-pointer"
            src={Logo}
            onClick={() => history.push("/")}
          />
        </div>

        {/* Menu */}
        <ul
          className={`absolute top-full left-0 w-full lg:w-[50%] flex flex-col bg-bgPrimary items-center text-center transition-all duration-300 ease-in-out overflow-hidden ${
            menuOpen ? "opacity-100 max-h-[400px]" : "opacity-0 max-h-0"
          } xl:opacity-100 xl:max-h-full xl:static xl:flex-row xl:space-x-4`}
        >
          <li className="w-full">
            <a
              onClick={() => history.push("/")}
              className="block py-2 md:py-0 hover:text-gray-300 text-[12px] lg:text-[14px] font-medium cursor-pointer"
            >
              {t("navbar.home")}
            </a>
          </li>
          <li className="w-full">
            <a
              className="block py-2 md:py-0 hover:text-gray-300 text-[12px] lg:text-[14px] font-medium cursor-pointer"
              onClick={() => scrollToSection("services")}
            >
              {t("navbar.services")}
            </a>
          </li>
          <li className="w-full">
            <a
              className="block py-2 md:py-0 hover:text-gray-300 text-[12px] lg:text-[14px] font-medium cursor-pointer"
              onClick={() => scrollToSection("galery")}
            >
              {t("navbar.gallery")}
            </a>
          </li>
          <li className="w-full">
            <a
              className="block py-2 md:py-0 hover:text-gray-300 text-[12px] lg:text-[14px] font-medium cursor-pointer"
              onClick={() => scrollToSection("contact")}
            >
              {t("navbar.contact")}
            </a>
          </li>
          {menuOpen ? (
            <div className="flex w-full items-center justify-end space-x-2 mt-2 mb-2 pr-2 py-1">
              <img
                alt="no encontrado"
                className="object-cover w-[12px]"
                src={Flageeuu}
              />
              <h2 className="font-semibold text-[12px]">English</h2>
              <IoIosArrowDown size={20} />
            </div>
          ) : (
            <div></div>
          )}
        </ul>

        {/* Call Today con numeros telefonicos */}
        <div className="bg-white w-[190px] lg:w-[360px] rounded-sm lg:rounded-md h-[44px] lg:h-[60px] flex items-center px-2 lg:px-4 md:flex">
          <div className="flex items-center w-full justify-between">
            <div className="flex items-center text-textPrimary font-semibold text-[10px] lg:text-[14px]">
              <FaPhoneVolume className="hidden md:block h-[12px] md:w-[20px] md:h-[20px] lg:w-[30px] lg:h-[30px]" />

              <h2 className="ml-0 lg:ml-2 text-[12px] lg:text-[16px]">
                {t("navbar.call")}
              </h2>
            </div>
            <div className="text-textPrimary font-semibold text-[12px] lg:text-[15px]">
              <h2>617-777-6772</h2>
              <h2>617-777-1348</h2>
            </div>
          </div>
        </div>

        {/* Menu Hamburguesa */}
        <button
          className="block xl:hidden text-white text-[26px] focus:outline-none"
          onClick={toggleMenu}
        >
          {menuOpen ? <HiX /> : <HiMenuAlt3 />}
        </button>

        {/* Info de contacto y bandera */}
        <div className="relative hidden md:flex items-center space-x-4 cursor-pointer">
          {/* Botón de idioma */}
          <div
            className="flex items-center space-x-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            <img
              alt="no encontrado"
              className="object-cover w-[30px]"
              src={languages[currentLang]?.flag}
            />
            <h2 className="font-semibold text-[14px]">
              {languages[currentLang]?.name}
            </h2>
            <IoIosArrowDown size={20} />
          </div>

          {/* Menú desplegable */}
          {isOpen && (
            <div className="absolute top-10 left-0 bg-white shadow-lg rounded-md w-40 p-2 text-gray-800 font-semibold">
              {Object.entries(languages).map(([key, { name, flag }]) => (
                <div
                  key={key}
                  className="flex items-center space-x-2 p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => changeLanguage(key as "en" | "es")}
                >
                  <img
                    alt={name}
                    className="object-cover w-[25px]"
                    src={flag}
                  />
                  <span>{name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
